import ItemView from './view'
import global from '@/util/mixin/global'
import Review from './partial/review'
// import ExportBox from '@/views/common/partial/export-verify'
import listComponent from '@/util/proto/listComponent'
import { saveFile, saveJSON } from '@/util'
import LicenseSelect from '../partial/license-select'

const stateIcon = [
  { value: 0, label: 'warning' },
  { value: 1, label: 'processing' },
  { value: 2, label: 'error' },
  { value: 3, label: 'default' },
  { value: 4, label: 'success' },
]

export default {
  extends: listComponent,
  mixins:[global],
  data() {
    let cols = []

    return {
      columns: [
        {
          title: '姓名',
          key: 'name',
          minWidth: 350,
          maxWidth: 450,
          render:(h,{row}) => {
            return (
              <div style="display: flex; align-items: center;">
                <sl-badge title={row.stateText} style={{'marginRight':'12px'}} status={row.stateIcon} />
                <div style="flex: 1 1 auto;">
                  <div class="tb-list-item-cell">
                    <div class="tb-list-item-cell-l">
                      <span style="font-size:14px;">{row.licenseRuleName}</span>
                      <sl-tag color={row.stateIcon} style={{'fontSize':'10px','marginLeft':'5px','opacity':'0.75'}}>{row.stateText}</sl-tag>
                    </div>
                    <div class="tb-list-item-cell-r">
                      <span>扣 {Math.abs(row.score)}分</span>
                    </div>
                  </div>
                  <div class="tb-list-item-cell">
                    <div class="tb-list-item-cell-l light" style="font-size:12px;">
                      <Icon custom="i-icon icon-car" /><span>{row.carLicenseNo}</span><span style="margin-left:8px;">{row.licenseName}</span>
                    </div>
                    <div class="tb-list-item-cell-r">{row.eventTimeText}</div>
                  </div>
                </div>
              </div>
            )
           
          }
        },
        {
          title: '证照编号',
          key: 'idcard',
          minWidth: 350,
          render: (h, { row }) => {
            return (
              <div style="display: flex; align-items: center;">
                <div style="flex: 1 1 auto;">
                  <div class="tb-list-item-cell">
                    <div class="tb-list-item-cell-l">
                      <span style="font-size:14px;color: rgba(0, 0, 0, 0.65);"><Icon custom="i-icon icon-kuaidiyuan" />{row.eventUserName}</span>
                    </div>
                    <div style="font-size:11px;color:rgba(0,0,0,.55);">
                      <Icon custom="i-icon icon-credentials" />
                      {row.eventUserIdcard}
                    </div>
                  </div>
                  <div class="tb-list-item-cell">
                    <div class="tb-list-item-cell-l light" style="font-size:12px;"><Icon custom="i-icon icon-company" style="margin-right:5px;" />{row.companyName}</div>
                    <span style="font-size:11px;color:rgba(0,0,0,.55);">
                      <Icon style={{'marginRight':'5px'}} type="md-phone-portrait" />
                      <span>{row.eventUserPhone}</span>
                    </span>
                  </div>
                </div>
              </div>
            )
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 185,
          fixed: "right",
          align: 'center',
          render: (h, {row}) => {
            let acts = []

            if( this.$a('license.violation.query') ){
              acts.push(<a on-click={()=>this.view(row)}>查看</a>)
            }
            if(this.$a('license.violation.review') && row.state == 0){
              acts.push(<a on-click={()=>this.review(row)}>审核</a>)
            }

            if(this.$a('license.violation.cancel') && row.state == 4){
              acts.push(<a on-click={()=>this.cancel(row)}>撤销</a>)
            }

            return this.$utils.link(acts, <Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params: {
        eventUserName: null,
        eventUserPhone: null,
        companyName: null,
        licenseId:null,
        districtCode: null,
        time:[]
      },
      loading: false,
      exportLoading:false,
    }
  },

  computed: {
    removeDisable() {
      return this.selection.length == 0
    },
    searchLabel() {
      return this.visibleSearchBox ? '收起' : '高级搜索'
    },
    importUrl() {
      return this.$request.courierImportUrl()
    }
  },
  watch: {
    $route(to, from) {
      this.search()
    }
  },
  created() {
    this.def = { ...this.params }
    if(this.isAdmin){
      this.columns.unshift({
        type: 'selection',
        width: 45,
        align: 'center'
      })
    }

    this.search()
  },

  methods: {

    search() {
      let { time ,  ...search} = this.params
      if(time && time.length == 2 && time[0] && time[1]){
        search.startDate = time[0]
        search.endDate = time[1]
      }

      let params = { search, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      //TODO 
      //if(this.$store.state.auth.userRole == 1){
        //params.search['province'] = this.$store.state.auth.user.orgVO.province
        // params.search['city'] = this.$store.state.auth.user.orgVO.city
        // params.search['area'] = this.$store.state.auth.user.orgVO.area
      //}
      this.$request.licenseViolations(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.flat(this.$utils.conv(resp.data.list || [], { 'eventTime': 'datetime','state':'licenseViolationState','state:stateIcon':stateIcon}))
          this.page.total = resp.data.total || 0
        }
      })
    },

    view(row) {
      this.$refs['itemView'].init(row.id , true)
    },

    cancel(row) {
      this.$ui.confirm(this.$request.licenseViolationCancel, `确定撤销 ${row.eventUserName}  的执法记录？撤销后扣分返还！`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.search()
        }else{
          this.$Message.error(resp.msg)
        }
      }).catch(e => {})
    },

    reset() {
      this.params = {}
      this.search()
    },

    review(row){
      this.$dialog({
        title: '审核',
        width: 550,
        paddingless: true,
        render: (h) => {
          return <Review data={row} />
        },
        onOk: () => {
          this.search()
        }
      })
    },

   
    handleExport(selection){

      let search = { ...this.params }

      if( selection && selection.length > 0 ){
        search = { ids:selection.map(i => i.id) }
      }

      return this.$request.licenseViolationExport( search ).then(resp => {
        saveFile(resp).then( resp => {
          if( resp ){
            this.$Message.error({content:resp.msg})
          }
        })
        return Promise.resolve()
      })
     
    },
  },
  render(){
    const tableScopedSlots = {
      batch:({selection , enable}) => {
        const acts = []
        if( this.$a('license.violation.export') ){
          acts.push(<sl-download style="margin-left:8px;" icon="md-download" click={() => this.handleExport(selection)}>导出</sl-download>)
        }
        return acts
      }
    } 
    return (
      <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}showCount={4} >
            <sl-search-item label="">
              <i-input v-model={this.params.eventUserName} placeholder="姓名" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.eventUserPhone} placeholder="电话" />
            </sl-search-item>
            {/*<sl-search-item label="">
              <sl-select v-model={this.params.examState} dict="examState" placeholder="考试状态" />
            </sl-search-item>*/}
            <sl-search-item label="">
              <i-input v-model={this.params.companyName} placeholder="企业名称" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-area v-model={this.params.districtCode} data-type="code" placeholder="所在区域" />
            </sl-search-item>
            <sl-search-item>
              <LicenseSelect multiple={false} v-model={this.params.licenseId} placeholder="证照类型" />
            </sl-search-item>
            <sl-search-item>
              <DatePicker v-model={this.params.time} type="datetimerange" style="width:100%;" placeholder="请选择时间"></DatePicker>
            </sl-search-item>
          </sl-search>
        </div>

        <div class="pg-bd">
          <sl-table scopedSlots={tableScopedSlots} showHeader={false} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} selectionKey={false}>
          </sl-table>
        </div>
        <ItemView ref="itemView" />
      </sl-page>
    )
  }
}
